import React from 'react';
import RichTextEditor from './RichTextEditor';

// 04-enforce.md 4.1 -- extraído de SubPanelTratos.jsx (rama `isContrato` del tab "Parámetros"):
// el editor de texto enriquecido del contrato de terminales. `value`/`onChange` sobre el campo
// `contrato_text` del container.

const DEFAULT_CONTRATO = `CONTRATO DE ARRENDAMIENTO Y PRESTACIÓN DE SERVICIOS DE TERMINALES DE PAGO<br><br>Que celebran por una parte PayTech Soluciones de Pago, y por la otra el Cliente cuyos datos se especifican en el presente documento, al tenor de las siguientes cláusulas:<br><br>1. OBJETO. PayTech otorga en arrendamiento las terminales de cobro especificadas, y el Cliente se obliga a pagar la renta mensual correspondiente y/o las comisiones pactadas por transacciones realizadas.`;

const SubPanelContrato = ({ value, onChange }) => (
  <div className="op-sub-panel-field">
    <label style={{fontSize:11,fontWeight:600,textTransform:'uppercase',letterSpacing:'0.08em',color:'rgba(255,255,255,0.35)',marginBottom:'var(--space-2)',display:'block'}}>Contenido del contrato</label>
    <RichTextEditor
      value={value ?? DEFAULT_CONTRATO}
      onChange={onChange}
      disabled={false}
      minHeight={240}
    />
    <div style={{ marginTop:'var(--space-4)', padding:'var(--space-3) var(--space-4)', background:'rgba(249,115,22,0.07)', border:'1px solid rgba(249,115,22,0.18)', borderRadius:'var(--radius-md)', color:'rgba(255,255,255,0.5)', fontSize:'12px', textAlign:'center', letterSpacing:'0.03em' }}>
      Contrato oficial de terminales de cobro
    </div>
  </div>
);

export default SubPanelContrato;
